import { Component, Inject, Input } from "@angular/core";
import { Team } from "@common/ADAPT.Common.Model/organisation/team";
import { ORGANISATION_CONFIGURATION_PAGE } from "@common/page-route-providers";
import { IAdaptRoute } from "@common/route/page-route-builder";
import { ConfigureFeatureBase } from "@org-common/lib/configuration/base-components/configure-feature-base";
import { IConfigItem } from "@org-common/lib/configuration/configuration.interfaces";
import { ConfigurationService } from "@org-common/lib/configuration/configuration.service";
import { ConfigArea } from "@org-common/lib/configuration/configuration-types";

@Component({
    selector: "adapt-configure-team-appearance",
    templateUrl: "./configure-team-appearance.component.html",
    standalone: false,
})
export class ConfigureTeamAppearanceComponent extends ConfigureFeatureBase {
    @Input() public configItem?: IConfigItem;
    @Input() public team!: Team;

    public constructor(
        configurationService: ConfigurationService,
        @Inject(ORGANISATION_CONFIGURATION_PAGE) private organisationConfigurationPageRoute: IAdaptRoute<any>,
    ) {
        super(configurationService);
    }

    public async initialiseData() {
        return Promise.resolve();
    }

    public onConfigureOrganisationGroupTypesClicked() {
        this.organisationConfigurationPageRoute.gotoRoute(undefined, { section: ConfigArea[ConfigArea.Team] }).subscribe();
    }
}
